import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";

import Anasayfa from "./pages/Anasayfa";
import Hakkimizda from "./pages/Hakkimizda";
import Ortaklik from "./pages/Ortaklik";
import YonetimKurulu from "./pages/YonetimKurulu";
import Tto from "./pages/Tto";
import Girisimcilik from "./pages/Girisimcilik";
import Isbirligi from "./pages/Isbirligi";
import Kumelenme from "./pages/Kumelenme";
import Medya from "./pages/Medya";
import Basvuru from "./pages/Basvuru";
import Iletisim from "./pages/Iletisim";

import Anasayfa_Eng from "./pages/Anasayfa_Eng";
import Hakkimizda_Eng from "./pages/Hakkimizda_Eng";
import Ortaklik_Eng from "./pages/Ortaklik_Eng";
import YonetimKurulu_Eng from "./pages/YonetimKurulu_Eng";
import Tto_Eng from "./pages/Tto_Eng";
import Girisimcilik_Eng from "./pages/Girisimcilik_Eng";
import Isbirligi_Eng from "./pages/Isbirligi_Eng";
import Kumelenme_Eng from "./pages/Kumelenme_Eng";
import Medya_Eng from "./pages/Medya_Eng";
import Basvuru_Eng from "./pages/Basvuru_Eng";
import Iletisim_Eng from "./pages/Iletisim_Eng";

import Header from "./Header_Tr.js";
import Header_Eng from "./Header_Eng.js";

import Footer from "./components/footer.js";
import Footer_Eng from "./components/footer_Eng.js";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/*" element={<Header />} />
          <Route path="/en/*" element={<Header_Eng />} />
        </Routes>
  
        <div className="inline-page background" >
        <div className="container">
        <Routes>
          <Route path="/" element={<Anasayfa />} />
          <Route path="/hakkimizda" element={<Hakkimizda />} />
          <Route path="/ortaklik-yapisi" element={<Ortaklik />} />
          <Route path="/yonetim-kurulu" element={<YonetimKurulu />} />
          <Route path="/tto" element={<Tto />} />
          <Route path="/girisimcilik" element={<Girisimcilik />} />
          <Route path="/isbirligi" element={<Isbirligi />} />
          <Route path="/kumelenme" element={<Kumelenme />} />
          <Route path="/medya" element={<Medya />} />
          <Route path="/basvuru" element={<Basvuru />} />
          <Route path="/iletisim" element={<Iletisim />} />
          
          <Route path="/en" element={<Anasayfa_Eng />} />
          <Route path="/en/about-us" element={<Hakkimizda_Eng />} />
          <Route path="/en/partnership-structure" element={<Ortaklik_Eng />} />
          <Route path="/en/board-of-directors" element={<YonetimKurulu_Eng />} />
          <Route path="/en/tto" element={<Tto_Eng />} />
          <Route path="/en/entrepreneurship" element={<Girisimcilik_Eng />} />
          <Route path="/en/collaboration" element={<Isbirligi_Eng />} />
          <Route path="/en/clusters" element={<Kumelenme_Eng />} />
          <Route path="/en/media" element={<Medya_Eng />} />
          <Route path="/en/application" element={<Basvuru_Eng />} />
          <Route path="/en/contact-us" element={<Iletisim_Eng />} />
        </Routes>
        </div>
        </div>

        <Routes>
          <Route path="/*" element={<Footer />} />
          <Route path="/en/*" element={<Footer_Eng />} />
        </Routes>

      </div>
    </Router>
  );
}

export default App;
